import { getCurrentScope, onScopeDispose } from 'vue'

/**
 * Hält gerade irgendwo jemand etwas Ungespeichertes in der Hand?
 *
 * Das Panel lädt sich nach einem Deploy still neu, wenn niemand hinsieht
 * (useVersionWatch). Gefragt wurden dabei nur der Editor (`isDirty`) und der
 * Katalog (`dirty`). Ein halb geschriebener Kommentar, eine Antwort, der Titel
 * einer neuen Seite oder ein offenes Formular in den Einstellungen stehen in
 * keinem der beiden, und genau die wären beim stillen Neuladen weg gewesen:
 * einmal kurz in einen anderen Tab gewechselt, zurückgekommen, Text verschwunden.
 * Gefunden am 02.10.2026 beim Einbau der Neuerungen-Liste.
 *
 * Jede Komponente, die Eingaben hält, die nicht sofort gespeichert werden,
 * meldet das hier an:
 *
 *   useEntwurf(() => text.value.trim() !== '')
 *
 * Abgemeldet wird beim Aushängen von selbst. Im Zweifel großzügig: Ein offenes
 * Formular zählt als Entwurf. Das kostet nur, dass statt des stillen Neuladens
 * der Balken erscheint, und dort entscheidet der Mensch.
 *
 * Dazu ein einziger `beforeunload`-Wächter für alle Angemeldeten. Er fragt
 * nach, wenn jemand mit offenem Entwurf auf „Jetzt aktualisieren" klickt oder
 * den Tab schließt. Editor und Katalog haben ihre eigenen Wächter schon.
 */

const pruefer = new Set<() => boolean>()
let waechterHaengt = false

/** Hält eine der angemeldeten Komponenten gerade Ungespeichertes? */
export function entwurfOffen(): boolean {
  for (const hatUngespeichertes of pruefer) {
    if (hatUngespeichertes()) return true
  }
  return false
}

function beimVerlassen(e: BeforeUnloadEvent): void {
  if (!entwurfOffen()) return
  e.preventDefault()
  // So empfiehlt es MDN (beforeunload_event, Stand 03.10.2026): preventDefault()
  // reicht ab Chrome/Edge 119, returnValue nur für ältere. Die Warnung
  // „deprecated" gilt dem Feld, nicht dieser Verwendung.
  e.returnValue = true
}

export function useEntwurf(hatUngespeichertes: () => boolean): void {
  pruefer.add(hatUngespeichertes)
  if (!waechterHaengt) {
    window.addEventListener('beforeunload', beimVerlassen)
    waechterHaengt = true
  }
  if (getCurrentScope()) {
    onScopeDispose(() => {
      pruefer.delete(hatUngespeichertes)
    })
  }
}
